import * as React from 'react';
import './Calendar.css';
import CalendarWrapper from '../../Calendar/CalendarWrapper';
import { Switch, Route } from 'react-router-dom';

const CalendarPage: React.FunctionComponent = props => {
	return <div className="calendarPage">
		<div className="calendarPage__wrapper">
			<div className="calendarPage__calendar calendarPage__myCalendar">
				<Switch>
					<Route path="/" exact={true}>
						<CalendarWrapper />
					</Route>

					<Route path="/:year/:month/:id">
						<CalendarWrapper/>
					</Route>
				</Switch>
				
			</div>

			<div className="calendarPage__payloads">

			</div>
		</div>
	</div>;
}

export default CalendarPage;
